import { ScissorOutlined, UnorderedListOutlined } from "@ant-design/icons"
import { Drawer, Typography, Descriptions, Divider, Button } from "antd"
import React, { useState } from "react"
import moment from "moment"

const { Link } = Typography

export default function MachineDetails({ data }) {
  const [open, setOpen] = useState(false)

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button onClick={showDrawer} size="small">
        Details
        <UnorderedListOutlined />
      </Button>
      <Drawer title="Order Details" placement="left" onClose={onClose} open={open}>
        {data && (
          <Descriptions column={1} size="small" bordered>
            <Descriptions.Item label="Client">{data.client?.client}</Descriptions.Item>
            <Descriptions.Item label="Manager">{data.user}</Descriptions.Item>
            <Descriptions.Item label="Manufacturer">{data.manufacturer?.company}</Descriptions.Item>
            <Descriptions.Item label="Created">
              {data.created && moment.unix(data.created.seconds).format("DD/MM/YYYY")}
            </Descriptions.Item>

            <Descriptions.Item>
              <Divider style={{ margin: "12px 0" }} />
            </Descriptions.Item>

            <Descriptions.Item label="Product">
              {data.selectedProduct?.product?.productName}
            </Descriptions.Item>
            <Descriptions.Item label="Product File">
              <Link href={data.selectedProduct?.product?.productFileUrl} target="_blank">
                View File
              </Link>
            </Descriptions.Item>
            <Descriptions.Item label="Material">{data.selectedProduct?.material}</Descriptions.Item>
            <Descriptions.Item label="Label Count">{data.labelCount}</Descriptions.Item>
            <Descriptions.Item label="Die Cut">{data.selectedProduct.knifeCode}</Descriptions.Item>
            <Descriptions.Item label="Plate">
              {data.selectedPlate?.code ? (
                data.selectedPlate.code
              ) : (
                <ScissorOutlined style={{ color: "#f5222d" }} />
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Drawer>
    </>
  )
}
